export enum DisplayTypeEnum {
  COMBOBOX,
  TEXTBOX,
  SECTION,
  SUB_SECTION,
  GROUP,
  TEXTAREA,
  RADIO,
  CHECKBOX

}


export function isField(val: string) {
  if (DisplayTypeEnum[DisplayTypeEnum.SECTION] !== val && DisplayTypeEnum[DisplayTypeEnum.SUB_SECTION] !== val && DisplayTypeEnum[DisplayTypeEnum.GROUP] !== val) {
    return true;
  } else {
    return false;
  }

}


export function isFieldOrGroup(val: string) {
  return (DisplayTypeEnum[DisplayTypeEnum.SECTION] !== val && DisplayTypeEnum[DisplayTypeEnum.SUB_SECTION] !== val);
}

export function isSectionWithNoSection(currentSubSections: any){
  let isOk = true;
  if(currentSubSections.displayType === DisplayTypeEnum[DisplayTypeEnum.SECTION]){
    currentSubSections.content.forEach(content => {
     if(!isFieldOrGroup(content.displayType)){
       isOk = false;
     }
   })
  }
  return isOk;
}

export function isGroup(val : string) {
  return DisplayTypeEnum[DisplayTypeEnum.GROUP] === val;
}
